import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-internal-server',
  templateUrl: './custom-internal-server.component.html',
  standalone: false
})
export class CustomInternalServerComponent {

}
